import { Injectable } from '@angular/core';

import { Route } from '@bca-shared/models/_enums';
import { RouterService } from '@bca-core/services/router.service';
import { IRootState } from '@bca-store/store.reducers';
import { selectIncompletedProducts } from '@bca-store/store.selectors';
import { Store, select } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { CanActivate } from '@angular/router';

@Injectable()
export class VerifyGuard implements CanActivate {
  constructor(
    private _store$: Store<IRootState>,
    private _routerService: RouterService
  ) {}

  canActivate(): Observable<boolean> {
    return combineLatest([
      this._store$.pipe(select(({ receipt }) => receipt.isVerified)),
      this._store$.pipe(select(selectIncompletedProducts))
    ]).pipe(
      take(1),
      map(([isVerified, incompletedProducts]) => {
        if (incompletedProducts.length > 0) {
          this._routerService.navigateTo(Route.USER_DATA);
          return false;
        }
        if (!isVerified) {
          this._routerService.navigateTo(Route.VERIFY);
          return false;
        }
        return true;
      })
    );
  }
}
